/**
 * 数据项类型
 */
export var DataItemType;
(function (DataItemType) {
    /**
     * 短文本
     */
    DataItemType[DataItemType["ShortText"] = 0] = "ShortText";
    /**
     * 长文本
     */
    DataItemType[DataItemType["LongText"] = 1] = "LongText";
    /**
     * 数值
     */
    DataItemType[DataItemType["Number"] = 2] = "Number";
    /**
     * 日期
     */
    DataItemType[DataItemType["Date"] = 3] = "Date";
    /**
     * 逻辑
     */
    DataItemType[DataItemType["Logic"] = 4] = "Logic";
    /**
     * 选人控件
     */
    DataItemType[DataItemType["StaffSelector"] = 5] = "StaffSelector";
    /**
     * 附件
     */
    DataItemType[DataItemType["Attachment"] = 6] = "Attachment";
    /**
     * 审批意见
     */
    DataItemType[DataItemType["ApprovalOpinion"] = 7] = "ApprovalOpinion";
    /**
     * 子表
     */
    DataItemType[DataItemType["Sheet"] = 8] = "Sheet";
    /**
     * 关联单选
     */
    DataItemType[DataItemType["RelevanceForm"] = 9] = "RelevanceForm";
    /**
     * 地理位置
     */
    DataItemType[DataItemType["Address"] = 10] = "Address";
    /**
     * 关联多选
     */
    DataItemType[DataItemType["RelevanceFormEx"] = 11] = "RelevanceFormEx";
    /**
     * 时间
     */
    DataItemType[DataItemType["Time"] = 12] = "Time";
})(DataItemType || (DataItemType = {}));
export const DataItemTypeValue = {
    ShortText(val, type) {
        return str(val, type);
    },
    LongText(val, type) {
        return str(val, type);
    },
    Number(val, type) {
        if (typeof val === "number") {
            return val;
        }
        else if (/^[0-9]+.?[0-9]*$/.test(val)) {
            return +val;
        }
        valError(val, type, "数值");
    },
    Logic(val, type) {
        if (typeof val === "boolean") {
            return val;
        }
        else if (val === "true") {
            valError(val, type, "逻辑");
            return true;
        }
        else if (val === "false") {
            valError(val, type, "逻辑");
            return false;
        }
    },
    Date(val, type) {
        if (val instanceof Date) {
            return val;
        }
        else if (typeof val === "string" && val) {
            try {
                let str = val
                    .replace(/-/g, "/") // iOS兼容
                    .replace(/T/g, " "); //修复2019-09-17T06:21:07.000字符不能new Date的问题
                let date = new Date(str);
                if (date.getFullYear() > 0) {
                    return date;
                }
            }
            catch (_a) { }
        }
        valError(val, type, "日期");
    },
    StaffSelector(val, type) {
        return strOrArray(val, type);
    },
    Attachment(val, type) {
        return strOrArray(val, type);
    },
    ApprovalOpinion(val, type) { },
    Sheet(val, type) {
        return strOrArray(val, type);
    },
    RelevanceForm(val, type) {
        return strOrObject(val, type);
    },
    Address(val, type) {
        return strOrObject(val, type);
    },
};
function str(val, type) {
    if (typeof val === "string") {
        return val;
    }
    else if (typeof val === "number") {
        return "" + val;
    }
    valError(val, type, "字符串");
}
function strOrArray(val, type) {
    if (typeof val === "string") {
        try {
            val = JSON.parse(val);
        }
        catch (_a) {
            console.log(`${type} 类型值解析错误! 值是: ${val}`);
        }
    }
    if (Array.isArray(val) && val.some((x) => typeof x === "object")) {
        return val;
    }
}
function strOrObject(val, type) {
    if (typeof val === "string") {
        try {
            val = JSON.parse(val);
        }
        catch (_a) {
            console.log(`${type} 类型值解析错误! 值是: ${val}`);
        }
    }
    if (typeof val === "object") {
        return val;
    }
}
function valError(val, type, valType) {
    console.error(`${type} 类型的控件值应该 ${valType}类型,但是它现在是 ${typeof val}`);
}
